import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appConfig: null,
    mxAccessToken: null,
    memberCoupon: null,
    uuid: null,
    teaType: null,
    wxid: null,
    refreshChannel: null,
  },
  mutations: {
    SET_APP_CONFIG(state, config) {
      state.appConfig = config
    },
    SET_MX_ACCESS_TOKEN(state, mxAccessToken) {
      state.mxAccessToken = mxAccessToken;
    },
    SET_MEMBER_COUPON(state, coupon) {
      state.memberCoupon = coupon;
    },
    SET_UUID(state, uuid) {
      state.uuid = uuid;
    },
    CLEAR_MX_ACCESS_TOKEN(state) {
      state.mxAccessToken = null;
    },
    CLEAR_MEMBER_COUPON(state) {
      state.memberCoupon = null;
    },
    CLEAR_UUID(state) {
      state.uuid = null;
    },
    SET_TEA_TYPE(state, teaType) {
      state.teaType = teaType;
    },
    CLEAR_TEA_TYPE(state) {
      state.teaType = null;
    },
    SET_WXID(state, wxid) {
      state.wxid = wxid;
    },
    CLEAR_WXID(state) {
      state.wxid = null;
    },
    SET_REFRESH_CHANNEL(state, refreshChannel) {
      state.refreshChannel = refreshChannel;
    },
    CLEAR_REFRESH_CHANNEL(state) {
      state.refreshChannel = null;
    },
  },
  actions: {
    setMxAccessToken({ commit }, mxAccessToken) {
      commit('SET_MX_ACCESS_TOKEN', mxAccessToken);
    },
    setMemberCoupon({ commit }, coupon) {
      commit('SET_MEMBER_COUPON', coupon);
    },
    setUuid({ commit }, uuid) {
      commit('SET_UUID', uuid);
    },
    clearMxAccessToken({ commit }) {
      commit('CLEAR_MX_ACCESS_TOKEN');
    },
    clearMemberCoupon({ commit }) {
      commit('CLEAR_MEMBER_COUPON');
    },
    clearUuid({ commit }) {
      commit('CLEAR_UUID');
    },
    setTeaType({ commit }, teaType) {
      commit('SET_TEA_TYPE', teaType);
    },
    clearTeaType({ commit }) {
      commit('CLEAR_TEA_TYPE');
    },
    setWxid({ commit }, wxid) {
      commit('SET_WXID', wxid);
    },
    clearWxid({ commit }) {
      commit('CLEAR_WXID');
    },
    setRefreshChannel({ commit }, refreshChannel) {
      commit('SET_REFRESH_CHANNEL', refreshChannel);
    },
    clearRefreshChannel({ commit }) {
      commit('CLEAR_REFRESH_CHANNEL');
    },
  },
  modules: {
  },
  plugins: [createPersistedState()]
}) 